import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import WhatshotIcon from '@mui/icons-material/Whatshot';

import styles from './User.module.css';

export default function Layout() {
	return (
		<Box>
            <Outlet />
	    </Box>
	)
};

